import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';


import Home from "./components/Home";
import About from "./components/About";
import Research from "./components/Research";
import Gallery from "./components/Gallery";


export default function App() {
    const location = useLocation();

    return (
        <>
            <AnimatePresence mode="wait">
                <Routes location={location} key={location.pathname}>
                    <Route index element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/research" element={<Research />} />
                    <Route path="/gallery" element={<Gallery />} />
                </Routes>
            </AnimatePresence>
            <SpeedInsights />
            <Analytics />
        </>
    );
};
